import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import Button from '~/components/Button';
import Modal from '~/components/Modal/Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const MediaPackDetailFirstTimeModalConfirmExit: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closeOnEsc={false}
    closeOnOverlayClick={false}
    size="lg"
  >
    <Modal.Header>
      <Text fontSize="2xl" fontWeight={500} marginBottom={4}>
        Save and exit, or keep editing?
      </Text>
      <Divider />
    </Modal.Header>
    <Modal.Body paddingX={6}>
      <Text>
        If you save and exit, you will be able to add the necessary information
        by editing your media pack after.
      </Text>
    </Modal.Body>
    <Modal.Footer showDivider={false} paddingX={6}>
      <Box flex={1}>
        <Flex justifyContent="space-between">
          <Button
            onClick={onConfirm}
            variant="link"
            fontWeight={500}
            colorScheme="primary"
            textTransform="none"
          >
            Save and Exit
          </Button>
          <Button onClick={onClose} colorScheme="primary">
            Keep editing
          </Button>
        </Flex>
      </Box>
    </Modal.Footer>
  </Modal>
);
